import { Component, OnInit, ViewChild } from '@angular/core';
import { AppelsService } from '../../service/appels.service';
import { Certificat } from 'src/app/model/certificat';
import { tap } from 'rxjs';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';

@Component({
  selector: 'app-certificats',
  templateUrl: './certificats.component.html',
  styleUrls: ['./certificats.component.css'],
})
export class CertificatsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  MoodleCertificats: Certificat[] = []; // anciennement "certificats"
  FODEcertificats: Certificat[] = [];
  allCertificats: Certificat[] = [];
  showSpinner = false;
  formattedStartDat!: string;
  formattedEndDat!: string;
  dateActuel!: any;

  currentPageFODE = 0;
  pageSizeFODE = 10;
  totalElementsFODE = 0;
  paginatedResponseFODE: PaginatedResponse<Certificat> | null = null;

  currentPageMoodle = 0;
  pageSizeMoodle = 10;
  totalElementsMoodle = 0;
  paginatedResponseMoodle: PaginatedResponse<Certificat> | null = null;

  currentPageAll = 0;
  pageSizeAll = 10;
  totalElementsAll = 0;
  paginatedAllCertificats: any[] = [];
  pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  constructor(
    private certificatService: AppelsService,
    private spinnerService: SpinnerServiceService
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.loadCertificateFromMoodlePaged();
    //this.loadCertificateFromFODEPaged();
  }

  loadCertificateFromMoodlePaged(page: number = 0, size: number = 10) {
    this.spinnerService.showSpinner();
    this.certificatService
      .getCertificateListFromMoodlePaged(page, size)
      .pipe(
        tap((response: PaginatedResponse<Certificat>) => {
          //console.log('Paginated response from Moodle: ', response);
          //console.log('Content response from Moodle:', response.content);
          this.paginatedResponseMoodle = response;
          if (response?.content) {
            this.MoodleCertificats = response.content
              .map((certificat) => {
                certificat.status = this.calculStatus(certificat);
                return certificat;
              })
              .sort((a, b) => a.fullname.localeCompare(b.fullname));
            this.currentPageMoodle = response.number;
            this.pageSizeMoodle = response.size;
            this.totalElementsMoodle = response.totalElements;
            this.updateAllCertificats();
          } else {
            console.warn(
              'Response ou content est undefined pour les Moodle certificats'
            );
            this.MoodleCertificats = [];
          }
          this.spinnerService.hideSpinner();
        })
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des certificats Moodle paginés:',
            error
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  loadCertificateFromFODEPaged(page: number = 0, size: number = 10) {
    this.spinnerService.showSpinner();
    this.certificatService
      .getCertificateListFromFODEPaged(page, size)
      .pipe(
        tap((response: PaginatedResponse<Certificat>) => {
          //console.log('Paginated response from FODE: ', response);
          //console.log('Content response from FODE:', response.content);
          this.paginatedResponseFODE = response;
          if (response?.content) {
            this.FODEcertificats = response.content
              .map((certif) => {
                certif.status = this.calculStatus(certif);
                return certif;
              })
              .sort((a, b) =>
                a.fullname && b.fullname !== null
                  ? a.fullname.localeCompare(b.fullname)
                  : 100
              );
            this.currentPageFODE = response.number;
            this.pageSizeFODE = response.size;
            this.totalElementsFODE = response.totalElements;
            this.updateAllCertificats();
          } else {
            console.warn('Response ou content est undefined');
            this.FODEcertificats = [];
          }
          this.spinnerService.hideSpinner();
        })
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des certificats FODE paginés:',
            error
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  updateAllCertificats() {
    this.allCertificats = [
      ...this.MoodleCertificats,
      ...this.FODEcertificats,
    ].sort((a, b) => a.fullname.localeCompare(b.fullname));

    this.totalElementsAll = this.allCertificats.length;
    this.updatePaginatedAllCertificats();
    // console.log('Tous les certificats mis à jour:', this.allCertificats);
  }

  updatePaginatedAllCertificats(): void {
    const startIndex = this.currentPageAll * this.pageSizeAll;
    const endIndex = startIndex + this.pageSizeAll;
    this.paginatedAllCertificats = this.allCertificats.slice(
      startIndex,
      endIndex
    );
  }

  onPageChangeAll(event: PageEvent) {
    //console.log('Page change event All:', event);
    this.currentPageAll = event.pageIndex;
    this.pageSizeAll = event.pageSize;
    this.updatePaginatedAllCertificats();
  }

  onPageChangeMoodle(event: PageEvent) {
    //console.log('Page change event Moodle:', event);
    this.currentPageMoodle = event.pageIndex;
    this.pageSizeMoodle = event.pageSize;
    this.loadCertificateFromMoodlePaged(
      this.currentPageMoodle,
      this.pageSizeMoodle
    );
  }

  onPageChangeFODE(event: PageEvent) {
    //console.log('Page change event FODE:', event);
    this.currentPageFODE = event.pageIndex;
    this.pageSizeFODE = event.pageSize;
    this.loadCertificateFromFODEPaged(this.currentPageFODE, this.pageSizeFODE);
  }

  refreshData() {
    this.loadCertificateFromFODEPaged(this.currentPageFODE, this.pageSizeFODE);
    this.loadCertificateFromMoodlePaged(
      this.currentPageMoodle,
      this.pageSizeMoodle
    );
  }

  private calculStatus(certificat1: Certificat): string {
    if (certificat1.enddate == null || certificat1.enddate == 0) {
      return 'En cours';
    }

    this.dateActuel = new Date().getTime();
    const endate = certificat1.enddate * 1000;

    if (endate > this.dateActuel) {
      certificat1.endDAte = endate;
      return 'En cours';
    } else {
      return 'Terminé';
    }
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'FORMATION' },
    { label: 'CERTIFICATS', url: '/dashboard/appels/certificats' },
  ];
}
